import React from 'react';
import { makeStyles, createStyles } from '@material-ui/core';
import { Menu, TextBlock, ExtendedMenuItemProps } from 'neon-design-system';

export interface SideBarMenuItemProps extends ExtendedMenuItemProps {
	_id?: string;
}

const useStyles = makeStyles(theme => createStyles({
	root: {
		flex: '1',
		backgroundColor: theme.palette.grey[800]

	},
	sideBar: {
		flex: '1',
		'& .Mui-selected': {
			fontWeight: 'bold'
		}
	},
	title: {
		paddingTop: theme.spacing(2),
		paddingLeft: theme.spacing(2),
		paddingBottom: theme.spacing(1)
	}
}));

const SidebarNavigation = ({id, menuItems, onChange}: {
	id?: string;
	menuItems: Array<SideBarMenuItemProps>;
	onChange: (menu: SideBarMenuItemProps) => void;
}): JSX.Element => {
	const classes = useStyles();

	return (
		<div
			id={id}
			className={classes.root}>
			<div className={classes.sideBar}>
				<TextBlock
					styleName="footnote"
					className={classes.title}
					ink="muted"
				>
					Manage Insights content
				</TextBlock>
				<Menu
					menuItemsSize="medium"
					onChange={(m): void => onChange(m)}
					menuItems={menuItems}
				/>
			</div>
		</div>
	);
};

export default SidebarNavigation;
